import React, { createContext, ReactNode, useContext, useState } from "react";

interface UserContextType {
  items: any[];
  setItems: any;
}

const BulkStateContext = createContext<UserContextType | undefined>(undefined);

export const BulkStateProvider = ({ children }: { children: ReactNode }) => {
  const [items, setItems] = useState<any[]>([]);
  return (
    <BulkStateContext.Provider value={{ items, setItems }}>
      {children}
    </BulkStateContext.Provider>
  );
};

export const useBulkRequestState = () => {
  const context: UserContextType | undefined = useContext(BulkStateContext);
  return context ?? {};
};
